import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import SmashTable from '../../../components/SmashTable/SmashTable';
import { TableActionItem } from '../../../components/SmashTable/SmashTableAction';
import { TableHeaders } from '../../../components/SmashTable/SmashTableHead';
import { useApiKeys } from '../hooks/useApiKey';
import ConfirmDeleteApiKeyModal from './ConfirmDeleteApiKeyModal';
import RotateKeyModal from './RotateKeyModal';

const ListApiKey = () => {
    const [isLoading, isError, apiKeys] = useApiKeys();

    const headers: TableHeaders[] = [{
        label: 'API Key name',
        accessor: 'label',
        sortable: false,
    },  
    {
        label: 'Created',
        accessor: 'created',
        type: 'date',
        sortable: true,
        sortbyOrder: "desc"
    }, 
    {
        label: 'Region',
        accessor: 'region',
        sortable: false,
    }]

    const actions: TableActionItem[] = [{
        name: 'delete',
        actionComponent: (props) => <ConfirmDeleteApiKeyModal item={props.item}>Delete</ConfirmDeleteApiKeyModal>,
    }, {
        name: 'rotate',
        actionComponent: (props) => <RotateKeyModal item={props.item}>Rotate Key</RotateKeyModal>,
    }]

    if (isLoading) {
        return <SmashSpinner />;
    }

    return (
        <SmashTable loading={isLoading} hasError={isError} headers={headers} items={apiKeys} tableActions={actions} textFallback={'No API Keys'}/>
    )
}


export default ListApiKey